import { FC } from "react";
import { Trans, TransProps } from "react-i18next";

import { MessageKey } from "./i18n.types";

export type FormattedMessageProps = TransProps<MessageKey>;

export const FormattedMessage: FC<FormattedMessageProps> = ({ components, ...props }) => {
  return (
    <Trans<MessageKey>
      {...props}
      components={{
        highlight: <span className="text-new-primary" />,
        danger: <span className="text-danger" />,
        ...components,
      }}
    />
  );
};
